import {
  ErrorResponseErrorItemCodeAccount,
  ErrorResponseErrorItemCodeAccountUserRequest,
  ErrorResponseErrorItemCodeAuth,
  ErrorResponseErrorItemCodeBatchDownload,
  ErrorResponseErrorItemCodeComment,
  ErrorResponseErrorItemCodeCommon,
  ErrorResponseErrorItemCodeCompany,
  ErrorResponseErrorItemCodeCoordinateSystem,
  ErrorResponseErrorItemCodeDongle,
  ErrorResponseErrorItemCodeDynamicAsset,
  ErrorResponseErrorItemCodeFile,
  ErrorResponseErrorItemCodeFileVersion,
  ErrorResponseErrorItemCodeFolder,
  ErrorResponseErrorItemCodeGeodata,
  ErrorResponseErrorItemCodeGeoid,
  ErrorResponseErrorItemCodeIntegrationKey,
  ErrorResponseErrorItemCodeLicense,
  ErrorResponseErrorItemCodeProject,
  ErrorResponseErrorItemCodeSharedFolder,
  ErrorResponseErrorItemCodeSharedView,
  ErrorResponseErrorItemCodeSkyMapConnect,
  ErrorResponseErrorItemCodeSubscription,
  ErrorResponseErrorItemCodeTag,
  ErrorResponseErrorItemCodeTiledModel,
  ErrorResponseErrorItemCodeUser,
} from '../../../../typings/api/skymap/rest/v1/.common';
import { translations as accountTranslations } from './account';
import { translations as accountUserRequestTranslations } from './account-user-request';
import { translations as authTranslations } from './auth';
import { translations as batchDownloadTranslations } from './batch-download';
import { translations as commentTranslations } from './comment';
import { translations as commonTranslations } from './common';
import { translations as companyTranslations } from './company';
import { translations as coordinateSystemTranslations } from './coordinate-system';
import { translations as dongleTranslations } from './dongle';
import { translations as dynamicAssetTranslations } from './dynamic-assets';
import { translations as fileTranslations } from './file';
import { translations as fileVersionTranslations } from './file-version';
import { translations as folderTranslations } from './folder';
import { translations as geodataTranslations } from './geodata';
import { translations as geoidTranslations } from './geoid';
import { translations as integrationTranslations } from './integration';
import { ErrorResponseErrorItemCodeLeica, translations as leicaTranslations } from './leica';
import { translations as licenseTranslations } from './license';
import { translations as projectTranslations } from './project';
import { translations as sharedFolderTranslations } from './shared-folder';
import { translations as sharedViewTranslations } from './shared-view';
import { translations as skymapConnectTranslations } from './skymap-connect';
import { translations as subscriptionTranslations } from './subscription';
import { translations as tagTranslations } from './tag';
import { translations as tiledModelTranslations } from './tiled-model';
import { translations as userTranslations } from './user';
import { ErrorResponseErrorItemCodeXsite, translations as xsiteTranslations } from './xsite';

export type ErrorResponseErrorItemCode =
  | ErrorResponseErrorItemCodeAccount
  | ErrorResponseErrorItemCodeAccountUserRequest
  | ErrorResponseErrorItemCodeAuth
  | ErrorResponseErrorItemCodeBatchDownload
  | ErrorResponseErrorItemCodeComment
  | ErrorResponseErrorItemCodeCommon
  | ErrorResponseErrorItemCodeCompany
  | ErrorResponseErrorItemCodeCoordinateSystem
  | ErrorResponseErrorItemCodeDongle
  | ErrorResponseErrorItemCodeDynamicAsset
  | ErrorResponseErrorItemCodeFile
  | ErrorResponseErrorItemCodeFileVersion
  | ErrorResponseErrorItemCodeFolder
  | ErrorResponseErrorItemCodeGeodata
  | ErrorResponseErrorItemCodeGeoid
  | ErrorResponseErrorItemCodeIntegrationKey
  | ErrorResponseErrorItemCodeLeica
  | ErrorResponseErrorItemCodeLicense
  | ErrorResponseErrorItemCodeProject
  | ErrorResponseErrorItemCodeSharedFolder
  | ErrorResponseErrorItemCodeSharedView
  | ErrorResponseErrorItemCodeSkyMapConnect
  | ErrorResponseErrorItemCodeSubscription
  | ErrorResponseErrorItemCodeTag
  | ErrorResponseErrorItemCodeTiledModel
  | ErrorResponseErrorItemCodeUser
  | ErrorResponseErrorItemCodeXsite;

//
// Note: Translations are rebuilt on each call in order to make sure i18next has been initialized.
// If i18next is not initialized, default Swedish is used.
//
// When AngularJS is replaced with React, these defaults can be removed, as i18next the always is
// initialed after login, before user can interact with anything else.
//
export const translations = (): Record<ErrorResponseErrorItemCode, string> => ({
  ...accountTranslations,
  ...accountUserRequestTranslations,
  ...authTranslations,
  ...batchDownloadTranslations,
  ...commentTranslations,
  ...commonTranslations(),
  ...companyTranslations,
  ...coordinateSystemTranslations,
  ...dongleTranslations,
  ...dynamicAssetTranslations,
  ...fileTranslations(),
  ...fileVersionTranslations(),
  ...folderTranslations(),
  ...geodataTranslations,
  ...geoidTranslations,
  ...integrationTranslations,
  ...leicaTranslations,
  ...licenseTranslations,
  ...projectTranslations,
  ...sharedFolderTranslations,
  ...sharedViewTranslations,
  ...skymapConnectTranslations,
  ...subscriptionTranslations,
  ...tagTranslations,
  ...tiledModelTranslations,
  ...userTranslations,
  ...xsiteTranslations,
});
